import React from "react";
import { Context, Cookie } from "@xt/xtbase";
const { XtContext } = Context;
import cx from "classnames";

import XtSvg from "components/xt/svg";

import styles from "./index.module.scss";

const Main: React.FC = () => {
  const [appState, appDispatch] = React.useContext(XtContext);

  const handleThemeToggle = () => {
    const theme = appState.theme === "dark" ? "light" : "dark";
    appDispatch({ payload: { theme } });
    Cookie.set("theme", theme);
  };

  return (
    <button onClick={handleThemeToggle} className={cx("btnTxt", "btnHover", styles.main)}>
      <XtSvg icon={`theme-${appState.theme === "dark" ? "light" : "dark"}-outlined`} />
    </button>
  );
};

export default Main;
